import { Component, Input } from '@angular/core';

@Component({
	selector: 'nm-form-group',
	templateUrl: './form-group.html'
})
export class NmFormGroup {
	@Input() label: string;
	@Input() class: string = 'col-sm-12';
	@Input() required: boolean = false;
	@Input() tips: string;
}


// WEBPACK FOOTER //
// ./src/widgets/form-group/form-group.ts